import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'cv-systemplate-cell-renderer',
    templateUrl: './systemplate-cell-renderer.component.html',
    styleUrls: ['./systemplate-cell-renderer.component.scss']
})
export class SystemplateCellRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;
    value: string;

    constructor() { }

    agInit(params: ICellRendererParams){
        this.params = params;
        this.value = params.value;
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.value = params.value;
        return true;
    }

    onDashboardClick(event: Event) {
        event.preventDefault();
        if (typeof this.params['dashboardClicked'] === 'function')
            this.params['dashboardClicked'](this.params.data.SystemTemplateKey);
    }
}
